import { useEffect, useState } from 'react';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import { ValidatorField } from '../../../components/ValidatorField';

const USERNAME_KEY = '@pwa:username'

interface UseUsernameReturn {
  username: string;
  saveUsername: (newUsername: string) => void;
  clearUsername: () => void;
  hasUsername: boolean;
}

export const useUsername = (): UseUsernameReturn => {
  const [username, setUsername] = useState<string>('');
  
  useEffect(() => {
    const storedUsername = ApiLocalStorage.get(USERNAME_KEY);

    if (storedUsername) {
      const cleanUsername = ValidatorField.removeSpecialCharsFromUsername(storedUsername);
      setUsername(cleanUsername);
    }
  }, []);
  
  const saveUsername = (newUsername: string) => {
    const cleanUsername = ValidatorField.removeSpecialCharsFromUsername(newUsername);
    ApiLocalStorage.set(USERNAME_KEY, cleanUsername);
    setUsername(cleanUsername);
  };
  
  const clearUsername = () => {
    ApiLocalStorage.remove(USERNAME_KEY);
    setUsername('');
  };
  
  return {
    username,
    saveUsername,
    clearUsername,
    hasUsername: Boolean(username)
  };
};
